import { render, staticRenderFns } from "./CreateDispenser.vue?vue&type=template&id=9651934e"
import script from "./CreateDispenser.vue?vue&type=script&lang=js"
export * from "./CreateDispenser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports